import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

interface DataSource {
  id: string
  name: string
  description?: string
  connectorType: string
  config: Record<string, any>
  projectId: string
  createdAt: string
  updatedAt: string
}

export const useDataSources = (projectId?: string) => {
  return useQuery<DataSource[]>({
    queryKey: ['dataSources', projectId],
    queryFn: async () => {
      if (!projectId) return []
      const response = await api.get(`/projects/${projectId}/data-sources`)
      return response.data
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useDataSource = (projectId: string, dataSourceId: string) => {
  return useQuery<DataSource>({
    queryKey: ['dataSources', projectId, dataSourceId],
    queryFn: async () => {
      const response = await api.get(`/projects/${projectId}/data-sources/${dataSourceId}`)
      return response.data
    },
    enabled: !!projectId && !!dataSourceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}